import React, { useState, useMemo, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Notes from "../assets/images/bet-frenzy/image.png";
import { toast } from "react-toastify";

// Dummy games data for demonstration
const allGames = Array.from({ length: 100 }, (_, i) => ({
  id: i + 1,
  image: `https://static.jackbit.com/${i + 1},077adaec08f2f6.webp`,
  category: ["30", "0", "9", "10", "37", "36"][i % 6],
  name: `Game ${i + 1}`,
}));

// Gradient fallback colors matching the theme
const GRADIENTS = [
  "linear-gradient(135deg, rgba(0, 230, 118, 0.7), rgba(0, 191, 165, 0.7))",
  "linear-gradient(135deg, rgba(0, 191, 165, 0.7), rgba(72, 85, 255, 0.7))",
  "linear-gradient(135deg, rgba(72, 85, 255, 0.7), rgba(0, 230, 118, 0.7))",
  "linear-gradient(135deg, rgba(0, 230, 118, 0.7), rgba(0, 150, 199, 0.7))",
  "linear-gradient(135deg, rgba(0, 191, 165, 0.7), rgba(0, 230, 118, 0.7))",
  "linear-gradient(135deg, rgba(0, 150, 199, 0.7), rgba(72, 85, 255, 0.7))",
];

const GameListComponent = ({
  gamesWithBg1,
  isLoading,
  setExpand,
  setQuery,
}) => {
  const [selectedCategory, setSelectedCategory] = useState();
  const [searchValue, setSearchValue] = useState("");
  const { pathname } = useLocation();
  // const configData = useSelector((state) => state.config.data);
  const {
    loading,
    error: profileError,
    data: profileData,
  } = useSelector((state) => state.getProfile);
  const filteredGames = useMemo(() => {
    let games = allGames;
    if (selectedCategory == 0) {
      return [];
    }
    if (selectedCategory !== "all") {
      games = games.filter((g) => g.category == selectedCategory);
    }
    if (searchValue) {
      games = games.filter((g) =>
        g.name.toLowerCase().includes(searchValue.toLowerCase())
      );
    }
    return games;
  }, [selectedCategory, searchValue]);
  const navigate = useNavigate();

  const categories = [
    { label: "Lobby", value: "30", num: 30 },
    { label: "My Favorites", value: "0", num: 0 },
    { label: "New Games", value: "9", num: 9 },
    { label: "Popular Slots", value: "10", num: 10 },
    { label: "Bonus Buy", value: "37", num: 37 },
    { label: "Megaways", value: "36", num: 36 },
  ];

  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1024);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname]);

  useEffect(() => {
    if (categories?.length && !selectedCategory) {
      setSelectedCategory(categories[0].value);
    }
  }, [categories]);

  return (
    <>
      <main className="casino-main">
        <div className="content">
          <div className="games-wrapper">
            {isLoading ? (
              <div className="casino-grid-no-data" style={{ display: "block" }}>
                <div
                  className="spinner-border text-success "
                  role="status"
                ></div>
              </div>
            ) : gamesWithBg1.length > 0 ? (
              <ul className="games">
                {gamesWithBg1.map((game, index) => (
                  <li key={game?._id} className="games-list">
                    <div
                      className="bg cursor-pointer text-center"
                      style={{
                        background: !game?.isBroken
                          ? `url(${game?.url_thumb}) center / cover no-repeat`
                          : GRADIENTS[index % GRADIENTS.length],
                        display: game?.isBroken ? "flex" : undefined,
                        alignItems: "center",
                        justifyContent: "center",
                        border: game?.isBroken
                          ? "1px solid #3a3f5c"
                          : undefined,
                        position: "relative",
                      }}
                      onClick={() => {
                        if (profileData) {
                          setExpand(false);
                          setQuery("");
                          document
                            .querySelectorAll(".opacity-based-on-search")
                            .forEach((el) => {
                              el.style.opacity = 1;
                            });
                          navigate("/game-launch", {
                            state: { game_id: game?.id, game: game },
                          });
                        } else {
                          toast.error("Please login first to continue.");
                          setExpand(false);
                          setQuery("");
                          document
                            .querySelectorAll(".opacity-based-on-search")
                            .forEach((el) => {
                              el.style.opacity = 1;
                            });
                          setTimeout(() => {
                            navigate("/");
                            sessionStorage.setItem("fromLogin", "true");
                          }, 2000);
                        }
                      }}
                    >
                      {game?.isBroken && (
                        <div
                          className="game-name-fallback"
                          style={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            textAlign: "center",
                            width: "90%",
                            zIndex: 1,
                            pointerEvents: "none",
                          }}
                        >
                          <span
                            className="game-name-text"
                            style={{
                              color: "#fff",
                              fontSize: "16px",
                              fontWeight: 600,
                              textShadow: "0 2px 8px rgba(0, 0, 0, 0.5)",
                              display: "block",
                              wordBreak: "break-word",
                              lineHeight: 1.4,
                            }}
                          >
                            {game?.game_name}
                          </span>
                        </div>
                      )}
                    </div>
                  </li>
                ))}
              </ul>
            ) : (
              <div className="casino-grid-no-data" style={{ display: "block" }}>
                <img
                  loading="lazy"
                  className="casino-no-data-image"
                  src={Notes}
                  alt="no-data"
                />
                <div className="text" text_key="CASINO__NO_GAMES">
                  No Games
                </div>
              </div>
            )}
          </div>
        </div>
      </main>
    </>
  );
};

export default GameListComponent;
